import { Award, Check, Users, Wallet } from 'lucide-react'
import { AwardFormSteps } from '../award-form'

const getStepIcon = (step: AwardFormSteps) => {
  switch (step) {
    case 'select_purse':
      return <Users className="h-4 w-4" />
    case 'review_students':
      return <Wallet className="h-4 w-4" />
    case 'confirm_award':
      return <Award className="h-4 w-4" />
    default:
      return null
  }
}

const getStepTitle = (step: AwardFormSteps) => {
  switch (step) {
    case 'select_purse':
      return 'Review Students'
    case 'review_students':
      return 'Select Funding'
    case 'confirm_award':
      return 'Confirm Award'
    default:
      return ''
  }
}

type Props = {
  currentStep: AwardFormSteps
}

export const StepIndicator = (props: Props) => {
  const { currentStep } = props
  const steps: AwardFormSteps[] = [
    'select_purse',
    'review_students',
    'confirm_award',
  ]
  const currentStepIndex = steps.indexOf(currentStep)

  return (
    <div className="flex items-center justify-center">
      <div className="flex items-center space-x-4">
        {steps.map((step, index) => {
          const isCompleted = index < currentStepIndex
          const isCurrent = index === currentStepIndex

          return (
            <div key={step} className="flex items-center">
              <div
                className={`
                  flex items-center justify-center w-8 h-8 rounded-full border-2 transition-colors
                  ${
                    isCompleted
                      ? 'bg-primary border-primary text-white'
                      : isCurrent
                        ? 'border-primary text-primary bg-white'
                        : 'border-gray-300 text-gray-400 bg-white'
                  }
                `}
              >
                {isCompleted ? (
                  <Check className="h-4 w-4" />
                ) : (
                  getStepIcon(step)
                )}
              </div>
              <span
                className={`ml-2 text-sm font-medium ${
                  isCurrent
                    ? 'text-primary'
                    : isCompleted
                      ? 'text-gray-900'
                      : 'text-gray-400'
                }`}
              >
                {getStepTitle(step)}
              </span>
              {index < steps.length - 1 && (
                <div
                  className={`w-8 h-0.5 mx-4 ${
                    index < currentStepIndex ? 'bg-primary' : 'bg-gray-300'
                  }`}
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
